import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "defaultOpen", "disabled", "placement", "tooltip", "use"];
import { Tooltip } from '../Tooltip/Tooltip';
import { Button } from './Button';
import { IconContainer } from '../Icons/IconContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ButtonTooltip = _ref => {
  let {
      children,
      defaultOpen,
      disabled,
      placement,
      tooltip,
      use
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, {
    defaultOpen: defaultOpen,
    disabled: !disabled,
    placement: placement,
    tooltip: tooltip,
    use: use,
    children: /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
      disabled: disabled,
      children: children
    }))
  });
};
ButtonTooltip.Icon = props => /*#__PURE__*/_jsx(IconContainer, Object.assign({}, props));